import React, {
  memo,
  useState,
  useRef,
  useContext,
  useEffect,
  useLayoutEffect,
} from 'react';
import MoreAction from './MoreAction';
import moment from 'moment';
import AddComment from './AddComment';
import {
  CommentActionType,
  CommentScrollCheckEvent,
  directUser,
} from '../directUser/index';
import { Tooltip } from 'antd';
import { useComment } from './CommentProvider';
import CommentListCtx from './CommentListCtx';
// import CommentListCtx from './CommentListCtx';
const Comment = (props) => {
  const {
    isGenesis = false,
    channelStatus: isResolved = false,
    name,
    comment: content,
    updatedAt: createdTime,
    module: relatedTag,
    handleShowAdd,
    id,
    // idx,
    component,

    showModuleInTag,
    showTag = true,
    email: commenterEmail,
    getInnerTooltipPopupContainer = () => {},
    componentTagModifier = (i) => i,
    projectId,
    identifier,
    threadStatus,
  } = props;

  // const { setInputIndxs, inputIdxs } = useContext(CommentListCtx);
  const isClient = commenterEmail.indexOf('@pwc.com') === -1;
  const wrapperClassName = isGenesis ? 'genesis' : 'normal';

  const { activeInput, handleActiveInput } = useContext(CommentListCtx);
  const [edit, setEdit] = useState(false);
  const editRef = useRef();
  const commentRef = useRef();

  const inputRef = useRef();

  const {
    setPanelVisible,
    commentScrollRecord,
    history,
    editComment,
    selfEmail,
    checkUserOnSamePage,
    urlMap,
    beforeJump,
    dateFormatter = (dateString) =>
      moment(dateString).format(`HH:mm A [ET]   MMM DD YYYY`),
  } = useComment();

  const canEdit =
    commenterEmail === selfEmail || (props.channelStatus && isGenesis);

  const handleClickThread = (e) => {
    handleShowAdd(e, true);

    // setInputIndxs([...inputIdxs, idx]);
  };

  const handleShowEdit = (state) => {
    setEdit(true);
    handleActiveInput(`edit-${id}`);
  };

  useEffect(() => {
    if (activeInput[0] === `edit-${id}`) {
      inputRef.current.setShowEdit(true);
    } else {
      setEdit(false);
      inputRef.current.setShowEdit(false);
    }
  }, [activeInput]);

  const changeEdit = (state) => {
    setEdit(state);
  };

  const handleTagClick = (e) => {
    e && e.stopPropagation();
    if (isResolved) {
      return;
    }
    directUser(
      history,
      urlMap,
      {
        moduleName: relatedTag,
        componentName: component,
        commentId: id,
        projectId,
        identifier,
        channelStatus: isResolved,
        channel: props.channel,
      },
      beforeJump || null,
      checkUserOnSamePage,
    );
    typeof setPanelVisible === 'function' && setPanelVisible(false);
  };

  const handleResolve = () => {
    editComment('EDIT', { ...props, channelStatus: true }, true);
  };

  const renderRelatedTag = () => {
    if (!isGenesis || !showTag) {
      return null;
    }

    if (!showModuleInTag) {
      return component ? (
        <div className="related-tag" onClick={handleTagClick}>
          {componentTagModifier(component)}
        </div>
      ) : null;
    }
    return (
      <div className="related-tag" onClick={handleTagClick}>
        {`${relatedTag} ${
          component && ` / ${componentTagModifier(component)}`
        }`}
      </div>
    );
  };

  const consumeCommentScrollRecord = () => {
    const anchorScrollRecord = commentScrollRecord.current;

    if (anchorScrollRecord) {
      if (
        anchorScrollRecord.channel === props.channel &&
        anchorScrollRecord.commentListType === props.commentListType &&
        anchorScrollRecord.actionType ===
          CommentActionType.CommentScrollIntoView
      ) {
        if (commentRef.current) {
          // wait util comment panel opened
          setTimeout(() => {
            commentRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start',
            });
          }, 300);
          commentScrollRecord.current = null;
        }
      }
    }
  };

  const consumeScrollRecordRef = useRef(null);
  consumeScrollRecordRef.current = consumeCommentScrollRecord;

  useLayoutEffect(() => {
    consumeCommentScrollRecord();
    const listener = () => {
      consumeScrollRecordRef.current && consumeScrollRecordRef.current();
    };
    window.addEventListener(CommentScrollCheckEvent, listener);

    return () => {
      window.removeEventListener(CommentScrollCheckEvent, listener);
    };
  }, []);

  return (
    <div
      ref={commentRef}
      className={`comment-wrapper ${wrapperClassName}`}
      onClick={handleClickThread}
    >
      <div className={`comment-header ${wrapperClassName}`}>
        <div className="comment-left">
          <div className="commenter-name">{`${name}${
            isClient ? `(Client)` : ''
          }`}</div>
          <div className="comment-time">{dateFormatter(createdTime)}</div>
        </div>
        <div
          className="comment-edit"
          ref={editRef}
          onClick={(e) => e.stopPropagation()}
        >
          {isGenesis &&
            (isResolved ? null : ( // <span className="appkiticon icon-circle-checkmark-fill" />
              <Tooltip
                title="Resolve"
                getPopupContainer={() =>
                  getInnerTooltipPopupContainer() || document.body
                }
                overlayClassName="adjust-tooltip-index"
              >
                <span
                  className="appkiticon icon-circle-checkmark-outline"
                  onClick={handleResolve}
                />
              </Tooltip>
            ))}

          {canEdit ? (
            <div onClick={(e) => e.stopPropagation()} className="action-menu">
              <MoreAction
                {...props}
                setEdit={handleShowEdit}
                editRef={editRef}
                commentRef={commentRef}
                threadStatus={threadStatus}
              />
            </div>
          ) : null}
        </div>
      </div>

      {renderRelatedTag()}

      <AddComment
        ref={inputRef}
        value={content}
        emitInputStatus={changeEdit}
        isEditInput
        {...props}
        key={edit}
        scrollToThreadTop
      />

      {!edit && (
        <pre
          className={`comment-body ${wrapperClassName}`}
          onClick={(e) => {
            console.log('e: ', e.target);
            if (e.target.className === 'atName') {
              const email = e.target?.getAttribute?.('data-email');
              console.log('email(getAttribute获取的): ', email);
              navigator.clipboard.writeText(email);
            }
          }}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      )}
    </div>
  );
};

export default memo(Comment);
